const tsApiService = {};

export default tsApiService;
